import React, { createContext, useContext, useEffect, useState } from "react";
import firebase from "firebase/app";
import { auth } from "../../services/firebase";

const AuthContext = createContext<{ user: firebase.User | null | undefined }>({ user: undefined });

export const AuthProvider: React.FC = ({ children }) => {
    const [user, setUser] = useState<firebase.User | null | undefined>(undefined); // undefined = loading

    useEffect(() => {
        return auth.onAuthStateChanged(setUser);
    }, []);

    return (
        <AuthContext.Provider value={{ user }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);